module.exports = __webpack_public_path__ + "assets/gcp_authenticated_icon.0dafcbf6.svg";